<template>
  <d-modal @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('price.importPrices') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form>
        <validation-observer ref="customer-prices-import-form" tag="form">
          <div class="form-group">
            <label for="name">
              {{ $t('ui.importType') }}:
            </label>

            <validation-provider
              rules="required"
              name="type"
              v-slot="{ errors }">
              <d-form-select
                v-model="type"
                :state="errors.length ? 'invalid' : null"
                :options="[{ 
                    value: 'update', 
                    text: $t('price.onlyPriceUpdate') 
                }, { 
                    value: 'delete_add', 
                    text: $t('price.removeAndReplacePrices') 
                }]" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <label for="name">
              {{ $t('price.xlsxFileWithPrices') }}:
            </label>

            <validation-provider
              rules="required"
              name="file"
              v-slot="{ errors }">
              <file-input
                :onChange="setNewFile"
                id="inputFileImport" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </validation-observer>
      </d-form>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        :disabled="importInProgress"
        @click.prevent="cancel">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        :disabled="importInProgress"
        @click.prevent="validateForm">
        <div
          v-if="importInProgress"
          class="spinner-border spinner-border-sm"
          role="status"></div>
        {{ $t('ui.importFile') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import jsonToFormData from 'json-form-data';
import Vue from 'vue';

export default {
  name: 'customer-prices-import-popup',
  props: {
    customerId: {
      default: 0,
      type: Number
    }
  },
  data () {
    return {
      file: null,
      type: 'update',
      importInProgress: false
    };
  },
  mounted () {
    this.file = null;
    this.type = 'update';
    this.importInProgress = false;
  },
  methods: {
    handleClose () {
      this.$bus.$emit('customer-prices-import-popup-close');
    },
    validateForm () {
      FormUtils.validate(this.$refs['customer-prices-import-form'], this.import);
    },
    setNewFile (event) {
      this.file = event.target.files[0];
    },
    import () {
      this.importInProgress = true;

      let importData = {
        type: this.type,
        file: this.file
      };

      this.$http.request({
        method: 'POST',
        url: '/customers/prices/import/' + this.customerId,
        headers: { 'Content-Type': undefined },
        transformRequest (data) {
          let dataToSend = jsonToFormData(data);
          return dataToSend;
        },
        data: importData
      }).then((response) => {
        if (response.data.success) {
          Vue.swal({
            title: this.$t('price.importSuccessfull'),
            html: this.$t('price.importSuccessfullDesc'),
            type: 'success',
            confirmButtonText: this.$t('ui.ok'),
            buttonsStyling: true,
            timer: 2000
          });
        }

        this.cancel();
        this.$bus.$emit('customer-prices-reload-needed');
        this.importInProgress = false;
      }).catch(error => {
        console.log(error);
        Vue.swal({
          title: this.$t('ui.importErrorTitle'),
          html: this.$t('ui.tryAgain'),
          type: 'warning',
          confirmButtonText: this.$t('ui.ok'),
          buttonsStyling: true
        });
        this.importInProgress = false;
      });
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>
